import actions from "./metaActions";
import { sendGetNearbyPartiesRequest } from "../../api/votify.api";

export const startLoadNearbyParties = () => async (dispatch) => {
  dispatch({ type: actions.START_NEARBY_PARTIES_REQUEST });
  const { ok, data, error } = await sendGetNearbyPartiesRequest();
  if (ok) {
    dispatch({ type: actions.LOAD_NEARBY_PARTIES, payload: data });
  } else {
    console.warn("Could not load nearby parties.");
    console.warn(error);
  }
  dispatch({ type: actions.END_NEARBY_PARTIES_REQUEST });
};
